import { render } from "./OrderStatusCheap.vue?vue&type=template&id=78ec40c8&scoped=true"
import script from "./OrderStatusCheap.vue?vue&type=script&lang=js"
export * from "./OrderStatusCheap.vue?vue&type=script&lang=js"

import "../style.scss?vue&type=style&index=0&id=78ec40c8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ec40c8"]])

export default __exports__